<template>
  <svg
    aria-hidden="true"
    tabindex="-1"
    role="presentation"
    class="icon icon-arrow-left"
    viewBox="0 0 32 32"
  >
    <path
      fill="#000000"
      d="M23.5,26.984L21.883,28.5L8.5,16L21.883,3.5L23.5,5.009L11.742,16L23.5,26.984z"
    />
  </svg>
</template>
<script>
export default {};
</script>
